/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentDefinition extends models.BaseDefinition {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentDefinition.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentDefinition>): WellArchitectedFrameworkAssessmentDefinition {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentDefinition(), model);
        WellArchitectedFrameworkAssessmentDefinition.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentDefinition>): WellArchitectedFrameworkAssessmentDefinition {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentDefinition.newInstance(<WellArchitectedFrameworkAssessmentDefinition> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentDefinition) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentDefinition.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentDefinition): boolean {
        if (models.BaseDefinition.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentDefinition.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.notification_configuration) {
            models.WellArchitectedFrameworkAssessmentNotification.fixupPrototype(this.notification_configuration);
        }
    }

    /**
     * Tenant owning the assessment
     */
    tenant_id: string;

    /**
     * Owner of the assessment
     */
    owner: string;

    /**
     * Approver of the assessment
     */
    approver: string;

    /**
     * Name of the assessment
     */
    name: string;

    /**
     * Description of the assessment
     */
    description: string;

    /**
     * States if the assessment is active or not
     */
    is_active: boolean;

    notification_configuration: models.WellArchitectedFrameworkAssessmentNotification;

}
